module.exports = __webpack_public_path__ + "img/viber-brands.4171b595.svg";